module.exports = __webpack_public_path__ + "img/help_home2.3180175e.png";